export const SUMMARY_BAND_BG = '#e8f7f2'

export const instructionBandStyle = {
	padding: '8px 14px 6px',
	fontSize: 11,
	color: '#9e9e9e',
	fontWeight: 500,
    textTransform: 'uppercase' as const,
	letterSpacing: '0.07em',
	borderBottom: '1px solid rgba(0,0,0,0.06)',
}

export const rowCheckboxStyle = { padding: 0 }
export const rowPriceStyle = { color: '#9e9e9e' }

export const selectedSummaryContainerStyle = {
	padding: '8px 14px',
	borderTop: '1px solid rgba(0,0,0,0.06)',
	background: SUMMARY_BAND_BG,
}

export const selectedSummaryTextStyle = {
	color: '#757575',
	marginBottom: 8,
	fontWeight: 500,
	display: 'block',
}

export const optionsEmptyContainerStyle = { padding: 16 }
export const optionsEmptyTextStyle = { color: '#9e9e9e' }
export const optionLabelContainerStyle = { flex: 1 }
export const optionCountTextStyle = { color: '#9e9e9e', display: 'block', marginTop: 1 }
export const optionExpandToggleStyle = { cursor: 'pointer', padding: 4 }
export const optionChipStyle = { fontSize: 11, height: 22 }

export const tabsRootStyle = {
	background: '#fafafa',
	borderBottom: '1px solid rgba(0,0,0,0.1)',
}

export const productsListGapStyle = (gap: number) => ({ gap })

export const rowContainerStyle = (
	selected: boolean,
	disabled: boolean,
	accent: string,
	gap: number,
) => ({
	display: 'flex',
	alignItems: 'center',
	padding: '9px 14px',
	gap,
	cursor: disabled ? 'not-allowed' : 'pointer',
	background: selected ? 'rgba(0, 153, 115, 0.06)' : '#fff',
	borderLeft: selected ? `3px solid ${accent}` : '3px solid transparent',
	transition: 'background .1s',
	opacity: disabled ? 0.45 : 1,
})

export const rowTitleStyle = (selected: boolean, accent: string) => ({
	flex: 1,
	color: selected ? accent : '#212121',
	fontWeight: selected ? 500 : 400,
})

export const rowRankBadgeStyle = (accent: string) => ({
	fontSize: 11,
	fontWeight: 700,
	color: '#fff',
	background: accent,
	borderRadius: '50%',
	width: 18,
	height: 18,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
})

export const selectedChipStyle = (accent: string) => ({
	borderColor: accent,
	color: accent,
	fontWeight: 500,
	fontSize: 12,
	height: 28,
	backgroundColor: '#fff',
})

export const optionRowStyle = (selected: boolean, accent: string) => ({
	display: 'flex',
	alignItems: 'center',
	padding: '10px 14px',
	gap: 10,
	cursor: 'pointer',
	background: selected ? 'rgba(0, 153, 115, 0.06)' : '#fff',
	borderLeft: selected ? `3px solid ${accent}` : '3px solid transparent',
	transition: 'background .1s',
})

export const optionRadioStyle = (selected: boolean, accent: string) => ({
	width: 18,
	height: 18,
	borderRadius: '50%',
	border: '2px solid',
	borderColor: selected ? accent : '#9e9e9e',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
})

export const optionRadioDotStyle = (accent: string) => ({
	width: 9,
	height: 9,
	borderRadius: '50%',
	background: accent,
})

export const optionNameStyle = (selected: boolean, accent: string) => ({
	color: selected ? accent : '#212121',
	fontWeight: selected ? 500 : 400,
})

export const optionCaretStyle = (expanded: boolean) => ({
	fontSize: 16,
	color: '#9e9e9e',
	transform: expanded ? 'rotate(180deg)' : 'none',
	transition: 'transform 0.18s',
	lineHeight: 1,
})

export const optionExpandedPanelStyle = (selected: boolean, accent: string) => ({
	padding: '6px 14px 10px 46px',
	borderLeft: selected ? `3px solid ${accent}` : '3px solid transparent',
	background: selected ? 'rgba(0, 153, 115, 0.03)' : '#fafafa',
  display: 'flex' as const,
  flexWrap: 'wrap' as const,
	gap: 5,
})

export const tabLabelStyle = (gap: number) => ({
	display: 'flex',
	alignItems: 'center',
	gap,
})

export const tabCountChipStyle = (accent: string) => ({
	height: 22,
	background: accent,
	color: '#fff',
	fontWeight: 600,
	fontSize: 11,
})
